<template>
  <div class="totalPie">
    <div class="tit">
      <p>历史水毁事件</p>
    </div>
    <div class="content">
      <div class="neirong" v-for="(item, i) in data" :key="i" @click="itemClick(item, i)">{{item.ydbEvent}}</div>
    </div>
  </div>
</template>

<script>
  import { shListData } from "@/api/api.js";
  export default {
    data() {
      return {
        data: null,
      };
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        shListData({}).then((res) => {
          this.data = res.data;
        })
      },
      itemClick(item, imm) {
        // console.log(item, imm)
        this.$emit('listClick', item)
        for (let i=0; i<this.data.length; i++) {
          let leftButtonDoc = document.getElementsByClassName("neirong")[i] || false;
          leftButtonDoc && leftButtonDoc.classList.remove('activeneirong');
          if (imm == i) {
            leftButtonDoc && leftButtonDoc.classList.add('activeneirong');
          }
        }
      }
    },
  };
</script>

<style scoped>
  .totalPie {
    width: 100%;
    height: 800px;
    background: url(../../common/images/dbg.png) no-repeat center;
    background-size: 100% 100%;
  }
  .content {
    margin-left: 5%;
    width: 90%;
    height: 94%;
    display: flex;
    flex-direction: column;
  }
  .neirong {
    color: #fff;
    font-size: 16px;
    /* height: 40px; */
    line-height: 2;
    cursor: pointer;
  }
  .activeneirong {
    color: #409EFF;
  }
  .neirong:hover {
    color: #409EFF;
  }
</style>
